import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations, sql } from 'drizzle-orm';
import {
  boolean,
  index,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid,
} from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { albums } from './albums';

export const photos = pgTable(
  'photos',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    url: text('url').notNull(),
    title: text('title'),
    /** Origem da foto importada (ex.: `instagram:<id da mídia>`) — evita importar a mesma duas vezes. */
    sourceId: text('source_id'),
    albumId: uuid('album_id')
      .references(() => albums.id)
      .notNull(),
    isActive: boolean('is_active').default(true),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
    updatedAt: timestamp('updated_at')
      .$onUpdate(() => new Date())
      .notNull(),
    ...softDelete,
  },
  (t) => [
    index('photos_album_id_idx').on(t.albumId),
    uniqueIndex('photos_album_source_idx')
      .on(t.albumId, t.sourceId)
      .where(sql`${t.sourceId} is not null and ${t.deletedAt} is null`),
  ],
);

export const photosRelations = relations(photos, ({ one }) => ({
  album: one(albums, {
    fields: [photos.albumId],
    references: [albums.id],
  }),
}));

export type Photo = InferSelectModel<typeof photos>;
export type CreatePhotoInput = InferInsertModel<typeof photos>;
export type UpdatePhotoInput = Partial<CreatePhotoInput>;
